import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const builderRoutes = [
  {
    path: 'segment-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.SegmentsView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/builder/list/PageBuilderListView.vue'),
        meta: { permissionAction: PermissionActions.SegmentsView },
      },
      {
        path: ':segmentBlockIdentity',
        component: () =>
          import('@/features/settingsManagement/builder/edit/PageBuilderEditView.vue'),
        meta: {
          showSidebar: false,
          layoutPadding: false,
          permissionAction: PermissionActions.SegmentBlocksUpdate,
        },
      },
    ],
  },
]
